import { useEffect, useState } from 'react';

import { useAppContext } from '../../../../../../app/Context';
import { getTimerMetaData } from '../../../../../../db/timer';

const useReadonlyTitle = () => {
  const { presentationId, activeSlideId } = useAppContext();

  const [title, setTitle] = useState('');

  useEffect(() => {
    if (!presentationId) return;
    if (!activeSlideId) return;
    const response = getTimerMetaData(presentationId, activeSlideId);
    if (!response) return;
    const { title = '' } = response;
    setTitle(title);
  }, [presentationId, activeSlideId]);

  return { title };
};

export default useReadonlyTitle;
